var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "id": "control_key_table"
    }
  }, [_vm.title ? _c('v-card-title', [_vm._v(" " + _vm._s(_vm.title) + " "), _c('v-spacer')], 1) : _vm._e(), _c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Address of Control Key")])])]), _c('tbody', _vm._l(_vm.subnet.controlKeys, function (ck) {
          return _c('tr', {
            key: ck
          }, [_c('td', [_c('img', {
            staticClass: "table_image",
            attrs: {
              "src": require("@/assets/key-".concat(_vm.imgColor, ".png")),
              "alt": ""
            }
          }), _vm._v(" " + _vm._s(ck) + " ")])]);
        }), 0)];
      },
      proxy: true
    }])
  }), _c('p', {
    staticClass: "threshold"
  }, [_vm._v(" " + _vm._s(_vm._f("pluralizeThreshold")(_vm.subnet.threshold)) + " needed to add a validator to the subnet. ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }